import { extend, localize } from 'vee-validate'
import ar from 'vee-validate/dist/locale/ar.json'
import en from 'vee-validate/dist/locale/en.json'
import moment from 'moment'
import {
  alpha as rule_alpha,

  alpha_dash as rule_alpha_dash,
  alpha_num as rule_alpha_num, between as rule_between, confirmed as rule_confirmed,

  digits as rule_digits, email as rule_email,

  integer as rule_integer,

  length as rule_length,
  max as rule_max, min as rule_min,

  regex as rule_regex, required as rule_required,
} from 'vee-validate/dist/rules'
// eslint-disable-next-line object-curly-newline
import {
  validatorCreditCard,

  validatorLowerCaseCharacter, validatorMaximumPhoneNumber,
  validatorMaxNumber, validatorMinNumber, validatorCustomMaxNumber,
  validatorMaxNumberValue, validatorMinimumFeeAmount,
  validatorMinimumPhoneNumber, validatorNumber,
  validateNigerianPhoneNumber, validatorNumerberOnly,
  validatorPassword, validatorTIN, validatorPositive,

  validatorSpecialCharacter,
  // validatorTwoDecimalNumbers,
  validatorTwoDecimalNumber, validatorUppercaseCharacter,
  validatorLimitedTwoDecimalNumbers,
  validatorUpToTwoDecimalNumbers,
  validatorUpToThreeDecimalNumbers,
  validatorUrlValidator,
  validatorDateDifference,
  validatorDateDifference2,
  isBusinessEmail,
  isValidEmail,
  validatorCardNumber,
  validatorCardDeliveredAndReceived,
  validatorAmountLimit,
  validatorDateLimit,
  validatorAmountCheckLimit,
  validatorAccountLimit,
  validatorMaxNum,
  validatorMinNum,
  validatorUpToFourDecimalNumbers,
  validatorUserID,

} from './validators'

// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const length = extend('length', rule_length)

export const max = extend('max', rule_max)

export const maxValue = extend('max-value', {
  validate: validatorMaxNumber,
  message: '{_field_} cannot exceed 100%',
})
export const minValue = extend('min-value', {
  validate: validatorMinNumber,
  message: '{_field_} cannot be less than 1%',
})
export const customMaxValue = extend('custom-maxValue', {
  validate: validatorCustomMaxNumber,
  message: '{_field_} cannot exceed 200%',
})
export const maxNumber = extend('max-number', {
  validate: validatorMaxNumberValue,
  message: '{_field_} cannot exceed 5',
})

export const positive = extend('positive', {
  validate: validatorPositive,
  message: '{_field_} cannot be less than 0',
})

export const number = extend('lessThanOne', {
  validate: validatorNumber,
  message: '{_field_} cannot be less than 1',
})

export const phoneNumber = extend('phoneNumber', {
  validate: value => {
    const result = validateNigerianPhoneNumber(value)
    return result.isValid || result.error
  },
  message: (fieldName, params, data) => {
    if (typeof data === 'string') {
      return `${fieldName}: ${data}`
    }
    return `${fieldName} must be exactly 11 digits starting with 0`
  },
})

export const credit = extend('credit-card', {
  validate: validatorCreditCard,
  message: 'It is not valid credit card!',
})

export const password = extend('password', {
  validate: validatorPassword,
  message: 'Your {_field_} must contain at least one uppercase, one lowercase, one special character and one digit',
})
export const validTIN = extend('validTIN', {
  validate: validatorTIN,
  message: 'Your {_field_} is not a valid TIN',
})
export const upTo4Decimal = extend('upTo4Decimal', {
  validate: validatorUpToFourDecimalNumbers,
  message: 'Your {_field_} should not exceed 4 decimal places.',
})

export const url = extend('url', {
  validate: validatorUrlValidator,
  message: 'URL is invalid',
})
export const idCheck = extend('id-check', {
  validate: validatorUserID,
  message: '{_field_} is invalid, Use valid format (e.g: QWETYU-0986)',
})

export const amount = extend('amount', {
  params: ['maxFee'],
  validate: validatorMinimumFeeAmount,
  message: '{_field_} cannot be greater than maximum',
})
export const amountLimit = extend('amount-limit', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed regulatory limit',
})
export const dateLimit = extend('date-limit', {
  params: ['minDate'],
  validate: validatorDateLimit,
  message: (fieldName, values) => {
    const formattedDate = moment(values.minDate).format('YYYY-MM-DD')
    return `${fieldName} must be a future date beyond ${formattedDate}`
  },
})
export const defaultATMCheck = extend('default-atm-check', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed {_field_} in maximum ATM transaction limit',
})
export const defaultPOSCheck = extend('default-pos-check', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed {_field_} in maximum POS transaction limit',
})
export const defaultOnlineCheck = extend('default-online-check', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed {_field_} in maximum Online transaction limit',
})
export const defaultAccountCheck = extend('default-account-check', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed {_field_} in maximum Account transaction limit',
})
export const accountLimitCheck = extend('account-limit-check', {
  params: ['maxFee'],
  validate: validatorAccountLimit,
  message: '{_field_} cannot be less than Limit Per Transaction',
})
export const limitAmount = extend('limit-amount', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed institution limit',
})
export const specialLimitAmount = extend('special-limit-amount', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed special institution limit',
})
export const checkAmountLimit = extend('check-amount-limit', {
  params: ['maxFee'],
  validate: validatorAmountCheckLimit,
  message: '{_field_} cannot exceed Fixed Deposit Ledger Balance',
})
export const checkAmount = extend('check-amount', {
  params: ['maxFee'],
  validate: validatorAmountLimit,
  message: '{_field_} cannot exceed Withdrawable Balance',
})

export const cardAwaiting = extend('cardNumber', {
  params: ['cardNumber'],
  validate: validatorCardNumber,
  message: '{_field_} cannot be greater than Number of Cards Awaiting Delivery',
})
export const cardDeliveredAndReceived = extend('cardDeliveredAndReceived', {
  params: ['cardDeliveredToDate', 'cardRequested'],
  validate: validatorCardDeliveredAndReceived,
  message: 'The sum of {_field_} and Total Number of Cards Delivered To Date must not be greater than Total Number of Cards Requested',
})

export const twoDecimal = extend('twoDecimal', {
  validate: validatorTwoDecimalNumber,
  message: '{_field_} should be up to 2 decimal places',
})
export const limited2Decimal = extend('limited2Decimal', {
  validate: validatorLimitedTwoDecimalNumbers,
  message: '{_field_} should be limited to 2 decimal places',
})
export const upTo2Decimal = extend('upTo2Decimal', {
  validate: validatorUpToTwoDecimalNumbers,
  message: '{_field_} should be up to 2 decimal places',
})
export const upTo3Decimal = extend('upTo3Decimal', {
  validate: validatorUpToThreeDecimalNumbers,
  message: '{_field_} should be up to 3 decimal places',
})

export const minPhoneVal = extend('minVal', {
  validate: validatorMinimumPhoneNumber,
  message: '{_field_} cannot be less than 7',
})

export const maxPhoneVal = extend('maxVal', {
  validate: validatorMaximumPhoneNumber,
  message: '{_field_} cannot be more than 11',
})
export const isUpperCase = extend('upperCaseChar', {
  validate: validatorUppercaseCharacter,
  message: '{_field_} must contain at least one uppercase character',
})
export const isLowerCase = extend('lowerCaseChar', {
  validate: validatorLowerCaseCharacter,
  message: '{_field_} must contain at least one lowercase character',
})
export const isNumber = extend('numberVal', {
  validate: validatorNumerberOnly,
  message: '{_field_} must contain at least one number',
})
export const isSpcialCharacter = extend('specialChar', {
  validate: validatorSpecialCharacter,
  message: '{_field_} must contain at least one special character',
})

export const isGreaterThanDate = extend('isGreaterThanDate', {
  params: ['maxDate'],
  validate: validatorDateDifference,
  message: '{_field_} cannot be less than Date of Acquisition',
})
export const isCommencementDateGreater = extend('isCommencementDateGreater', {
  params: ['maxDate'],
  validate: validatorDateDifference2,
  message: '{_field_} cannot be less than Operating License Issued Date',
})
export const checkBusinessEmail = extend('checkBusinessEmail', {
  params: ['maxDate'],
  validate: isBusinessEmail,
  message: '{_field_} not valid, use a company email address',
})
export const isEmailAddress = extend('isEmailAddress', {
  params: ['maxDate'],
  validate: isValidEmail,
  message: '{_field_} not a valid email',
})
export const isAuthorisationMax = extend('authorisation-max', {
  params: ['maxNum'],
  validate: validatorMaxNum,
  message: '{_field_} cannot be greater than 9999999999',
})
export const isAuthorisationMin = extend('authorisation-min', {
  params: ['minNum'],
  validate: validatorMinNum,
  message: '{_field_} cannot be less than 100000',
})

// Install English and Arabic localizations.
localize({
  en: {
    messages: en.messages,
    names: {
      email: 'Email',
      password: 'Password',
    },
    fields: {
      password: {
        min: '{_field_} is too short, you want to get hacked?',
      },
    },
  },
  ar: {
    messages: ar.messages,
    names: {
      email: 'البريد الإلكتروني',
      password: 'كلمة السر',
    },
    fields: {
      password: {
        min: 'كلمة السر قصيرة جداً سيتم اختراقك',
      },
    },
  },
})
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
